import axiosConfig from "./axiosConfig";

export interface FileDownloadUrl {
  url: string;
}

const getSiteFileDownloadUrl = async (
  authToken: string,
  siteId: string,
  siteFileType: string | null,
  fileName: string,
  fileGuid: string | null,
  isAttachment?: boolean,
  userOrgId?: string
): Promise<FileDownloadUrl> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/file/${fileGuid}${
      userOrgId ? `?userOrgId=${userOrgId}` : ""
    }`,
    {
      fileName,
      siteFileType,
      isAttachment,
    },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSiteFileDownloadUrl;
